import { useEffect, useState } from "react";
import { useLang } from "@/LangContext";

const split = (ms) => {
  const s = Math.max(0, Math.floor(ms / 1000));
  return [Math.floor(s / 86400), Math.floor((s % 86400) / 3600), Math.floor((s % 3600) / 60), s % 60];
};

export default function Countdown({ endsAt, compact = false }) {
  const { t } = useLang();
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  const parts = split(new Date(endsAt).getTime() - now);
  const labels = [t.auction.days, t.auction.hours, t.auction.minutes, t.auction.seconds];

  return (
    <div data-testid="auction-countdown" className={`grid grid-cols-4 ${compact ? "gap-2" : "gap-3 sm:gap-4"}`}>
      {parts.map((v, i) => (
        <div key={labels[i]} className={`border border-white/10 bg-[#0C0F16] text-center ${compact ? "p-3" : "p-4 sm:p-6"}`}>
          <div
            data-testid={`countdown-${["days", "hours", "minutes", "seconds"][i]}`}
            className={`font-display font-bold tabular-nums text-amber-400 ${compact ? "text-2xl" : "text-4xl sm:text-6xl"}`}
          >
            {String(v).padStart(2, "0")}
          </div>
          <div className="mt-1 font-code text-[10px] uppercase tracking-[0.3em] text-slate-500">{labels[i]}</div>
        </div>
      ))}
    </div>
  );
}
